/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `Payload` type.
 */

type Payload = {
  id: string;
};

/**
 * Retry order.
 */

export async function retryOrder(client: AxiosInstance, payload: any): Promise<string> {
  return await client
    .post(resolveAppUrl('retryOrder', { interpolations: { id: payload.id } }), payload)
    .then(({ data }) => data.data);
}

/**
 * Export `usePostRetryOrder`.
 */

export function usePostRetryOrder() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await retryOrder(client, payload);
    }
  });
}
